import { Reducer } from 'react';

export const withReducerLogger = <S, A extends { type: string }>(
  reducer: Reducer<S, A>
): Reducer<S, A> => {
  return (state: S, action: A) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[reducer]', action.type, action);
    }
    return reducer(state, action);
  };
};
